import {
  Button,
  Alert,
  Divider,
  Grid,
  Snackbar,
  IconButton,
  Typography,
  Box,
  Modal,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import { UserResponse } from "../../app/models/responseModels/userResponse";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import agent from "../../app/api/agent";
import { toast } from "react-toastify";
import getAxiosError from "../../app/api/axiosError";
import ConfirmModal from "../../components/common/modalPopup/ConfirmModal";


type UserOneTimePasswordButtonProps = {
  userInfo: UserResponse;
};

const UserOneTimePasswordButton = ({
  userInfo,
}: UserOneTimePasswordButtonProps) => {
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [isOtpLoading, setOtpLoading] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [otp, setOtp] = useState("");

  const getOtpByCall = async() => {
    try{
      setConfirmModalOpen(false);
      setOtpLoading(true);
      setOpenOtpModal(true);
      const response = await agent.UserAgent.generateOtpForuser(userInfo.id);
      if (response.isSuccess) {
        setOtpLoading(false);
        setOtp(response.data);
      }
      if (!response.isSuccess) {
        setOtpLoading(false);
        toast.error(response.message!, {
          toastId: "userOTPGeneration",
        });
      }
    } catch (error) {
      setOtpLoading(false);
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "userOTPGenerationException",
      });
    }
    return true;
  }

  const handleModalClose = () => {
    setOpenOtpModal(false);
  };
  const handleCopyClick = () => {
    navigator.clipboard.writeText(otp);
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleButtonClick = () => {
    setConfirmModalOpen(true);
  };

  const handlePasswordConfirmModalClose = (value : boolean) => {
    setConfirmModalOpen(value);
  };

  const consoleConfirmModalClose = ()=> {
    setConfirmModalOpen(false);
  };

  return (
    <>
      <Button
        onClick={handleButtonClick}
        variant="contained"
        size="small"
      >
        Generate
      </Button>
      <ConfirmModal
          onClose={handlePasswordConfirmModalClose}
          asyncOperation={getOtpByCall}
          open={confirmModalOpen}
          closeModalAfterSubmit= {true}
          closeSubmitModal={consoleConfirmModalClose}
          confirmMessage={`Are you really want to
           generate one time Password for ${userInfo.userName}?`}
        ></ConfirmModal>
      <Modal open={openOtpModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            pt: 2,
            borderRadius: 4,
            textAlign: "center",
          }}
        >
          <Typography variant="h3" marginBottom={4} gutterBottom>
            Generated Password
            <Divider />
          </Typography>
          <Grid container>
            <Grid
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              {isOtpLoading && <CircularProgress color="primary" />}
              {!isOtpLoading && <>
                {otp ? <><Typography variant="h4" gutterBottom>
                  {otp}
                </Typography>
                <IconButton onClick={handleCopyClick}>
                  <FileCopyIcon color="primary" />
                </IconButton></> : "No OTP generated"}
              </>}
            </Grid>
          </Grid>
          <Snackbar
            open={openSnackbar}
            autoHideDuration={500}
            onClose={handleSnackbarClose}
          ><Alert
              onClose={handleSnackbarClose}
              severity="success"
              variant="standard"
              sx={{ width: "100%" }}
            >Copied</Alert>
          </Snackbar>
          <Button sx={{ mt: 3 }} onClick={handleModalClose}>
            Close
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default UserOneTimePasswordButton;
